// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"c6473e86e26e2f76","736":"e0cf02feb8c23cc9","818":"0051141b579e0038"}[chunkId] + ".js";
};